import { API } from '@/api';
//import axios from 'axios';

const state = {
  getShowDrawer: (State) => State.showDrawer,
};

const getters = {

};
const actions = {
  async getFirmaMat({commit, State},{id}) {
    const response = await API.post(`/sign/sigmat/${id}`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async addFirma({commit, State},{id}) {
    const response = await API.post(`/sign/signature/${id}`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async SignatureValue({commit, State},{clienteId, documentId, request}) {
    const response = await API.post(`/firma/${clienteId}/${documentId}/signatureValue`, request);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async getFirmas({commit, State},{id}) {
    const response = await API.get(`/sign/signatures/${id}`);
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
  async firmarAlgoritmo({commit, State},{clienteId, documentId, request}) {
    const response = await API.post(`/firma/${clienteId}/${documentId}/signedInfo`, request, {dataType: 'json'});
    if (response === undefined) {
      console.error('undefined response');
      return null;
    }
    if (response.data === undefined) {
      console.error('undefined response.data');
      return null;
    }
    return response.data;
  },
};
const mutations = {
  
};

export default {
  actions,
  mutations,
  getters,
  state,
};
